import type { PublicDocument } from '../types/documentCapture.types';

/**
 * Public customer document access (86d3udn5u, T8). DELIBERATELY does not use the shared `apiClient`:
 * that client attaches the JWT and its 401 interceptor redirects to /login — neither of which may
 * ever happen on a login-free page. This is plain `fetch` for the JSON payload; the PDF itself is
 * loaded straight from {@link PublicDocumentService.fileUrl} by react-pdf (no auth header needed).
 */

// Same base the app uses (dev: the Vite proxy value; prod: "/api"). No trailing slash.
const API_BASE = (import.meta.env.VITE_API_BASE_URL ?? '/api').replace(/\/$/, '');
const PUBLIC_BASE = `${API_BASE}/public/documents`;

class PublicDocumentService {
  /** Resolve a token to its minimal payload, or null for ANY failure (the one neutral answer). */
  async get(token: string): Promise<PublicDocument | null> {
    try {
      const res = await fetch(`${PUBLIC_BASE}/${encodeURIComponent(token)}`, {
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return null;
      return (await res.json()) as PublicDocument;
    } catch {
      // Network/parse failure — treat as unavailable; the page shows its neutral state.
      return null;
    }
  }

  /** Direct URL for the PDF (react-pdf fetches it; plain <a> downloads it). No auth. */
  fileUrl(token: string): string {
    return `${PUBLIC_BASE}/${encodeURIComponent(token)}/file`;
  }
}

export const publicDocumentService = new PublicDocumentService();
